import React, { memo } from 'react';
import { styled } from 'linaria/react';
import { mediaBreakPointDown } from '../../../utils/breakpoint';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1flksht"
});
const LoadMore = ({
  onClickSeeMore
}) => {
  const onClick = () => {
    if (onClickSeeMore) {
      onClickSeeMore();
    }
  };
  return <Wrapper>
      <button type="button" onClick={() => onClick()}>
        Tìm hiểu thêm về các chương trình
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
          <g fill="none" fillRule="evenodd">
            <path stroke="#38699F" strokeLinecap="round" strokeWidth="1.5" d="M1.125 3L6.75 8 1.125 13" transform="translate(1 1)" />
            <path stroke="#FFF" strokeWidth=".1" d="M0 0H9V16H0z" opacity=".01" transform="translate(1 1)" />
          </g>
        </svg>
      </button>
    </Wrapper>;
};
LoadMore.defaultProps = {};
LoadMore.propTypes = {};
export default memo(LoadMore);

require("../../../../.linaria-cache/src/components/PartnerProgram/LoadMore/LoadMore.linaria.module.css");